<div class="seller-videos-container" *ngIf="carouselVideos?.length > 0">
  <div class="seller-videos-header">
    {{
      'i18n.productDetail.sellerDetail.relatedVideos'
        | translate: { value: carouselVideos?.length }
    }}
  </div>
  <div
    class="seller-videos-carousel-content"
    [ngClass]="
      (platformService?.isTouchExperience$ | async)
        ? platformService?.platformType ===
          platformService?.platformEnum?.tablet
          ? 'tablet'
          : 'mobile'
        : 'desktop'
    "
  >
    <button
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      class="previous-arrow"
      [ngClass]="
        recentSwiperRef?.swiper.isBeginning ? 'swiper-button-disabled' : ''
      "
      (click)="recentSwiperRef?.swiper.slidePrev()"
    >
      <ion-icon
        slot="icon-only"
        name="arrow-back-circle-outline"
        data-cy="swiper-back-icon"
      ></ion-icon>
    </button>
    <swiper-container
      #recentSwiperRef
      navigation-prev-el=".previous-arrow"
      navigation-next-el=".next-arrow"
      resize-observer="true"
      observer="true"
      slides-per-view="auto"
      space-between="20"
      center-insufficient-slides="true"
      (beforeinit)="beforeMainInit($event?.detail[0])"
      (init)="setSwiperInstance($event.detail[0])"
      data-cy="card-swiper"
      class="recent-swiper"
    >
      <swiper-slide
        *ngFor="
          let sellerVideo of carouselVideos | slice: 0 : carouselVideos.length;
          let index = index
        "
      >
        <div class="video-player">
          <app-usf-video-player
            [videoID]="sellerVideo.videoId"
            [sequence]="(index + 3).toString()"
          ></app-usf-video-player>
        </div>
      </swiper-slide>
    </swiper-container>
    <button
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      class="next-arrow"
      [ngClass]="recentSwiperRef?.swiper.isEnd ? 'swiper-button-disabled' : ''"
      (click)="recentSwiperRef?.swiper.slideNext()"
    >
      <ion-icon
        slot="icon-only"
        name="arrow-forward-circle-outline"
        data-cy="forward-swiper-icon"
      ></ion-icon>
    </button>
  </div>
</div>
